/*
  Page names Ask Cadenza is told when a page doesn't report its own view.
  Matched longest-prefix first; names are what users see in the sidebar.
*/
const PAGE_NAMES = [
  ["/analysis/reconciliation/as-built", "As-built Reconciliation"],
  ["/analysis/reconciliation", "Reconciliation"],
  ["/analysis/closure", "Closure & Draindown"],
  ["/analysis/ensembles", "Ensembles"],
  ["/analysis/npv", "NPV & Cashflow"],
  ["/project-details", "Project Overview"],
  ["/simulation-config", "Simulation Setup"],
  ["/snapshot-viewer", "Snapshot Viewer"],
  ["/kinetics-fitting", "Kinetics Fitting"],
  ["/operational-data", "Operational Data"],
  ["/hydrodynamics", "Hydrodynamics"],
  ["/waterbalance", "Water Balance"],
  ["/maintenance", "Maintenance"],
  ["/management", "Task Board"],
  ["/lab-tests", "Lab Tests"],
  ["/kinetics", "Kinetics"],
  ["/leaching", "Leaching"],
  ["/results", "Results"],
  ["/climate", "Climate"],
  ["/heaps", "Heaps"],
  ["/logs", "Logs"],
  ["/run", "Run Simulation"],
  ["/documents", "Documents"],
  ["/transmittals", "Transmittals"],
];

export const pageNameFor = (pathname) => {
  const match = PAGE_NAMES.find(
    ([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
  return match ? match[1] : null;
};
